import React, { memo, useContext } from "react";
import * as Common from "bodycodi/cmap/app/js/common";
import Dialog from "@material-ui/core/Dialog";
import "bodycodi/cmap/app/css/common/alert.css";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// assets
import LinkIcon from "bodycodi/cmap/app/svg/icon_link.svg";
import KakaoIcon from "bodycodi/cmap/app/svg/icon_kakao.svg";

// hooks
import useKakaoChannel from "../../hooks/useKakaoChannel";

interface ShareAlertProps {
  open: boolean;
  setOpen: (b: boolean) => void;
  /**
   * @description type이 tab일 시 Alert 다이얼로그의 헤더 부분이 탭 형태로 전환됩니다. tab을 사용할 경우 tabs, activeTab, handleActiveTab 를 추가적으로 전달해줘야합니다.
   * @default only
   * @type 'only' | 'tab'
   */
  type?: "only" | "tab";
  tabs?: {
    [key: string]: string;
  };
  activeTab?: string;
  handleActiveTab?: (t: string) => () => void;

  header?: string;
  description: string;
  link: string;
  program: {
    title: string;
    description: string;
    mainCoverImgUrl: string;
  };
  closeAlert: VoidFunction;
}

const ShareAlert: React.FC<ShareAlertProps> = ({
  open,
  header,
  description,
  link,
  program,
  tabs,
  activeTab,
  setOpen,
  closeAlert,
  handleActiveTab,
  type = "only",
}) => {
  const { dispatch } = useContext(DispatchContext);
  const { shareKakaoMessage } = useKakaoChannel();

  const handleClose = () => {
    setOpen(false);
    if (!Common.isEmpty(closeAlert)) {
      closeAlert();
    }
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(link).then(() => {
      handleClose();
      dispatch({ type: "UPDATE", data: { toast: true, toastText: "링크가 복사되었습니다." } });
    });
  };

  const handleClickKakao = () => {
    shareKakaoMessage({
      title: program?.title || "",
      description: program?.description,
      imageUrl: program?.mainCoverImgUrl,
      url: link,
    });
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} className="alert-pop" classes={{ paper: "alert" }}>
      {type === "only" && (
        <div className="alert-header">
          <span>{header}</span>
        </div>
      )}
      {type === "tab" && tabs && (
        <div className="alert-tab">
          {Object.entries(tabs).map(([key, label]) => (
            <span
              key={key}
              className={key === activeTab ? "tab isActive" : "tab"}
              onClick={handleActiveTab?.(key)}
            >
              {label}
            </span>
          ))}
        </div>
      )}

      <div className="alert-body share">
        <div className="body-text">{description}</div>
        <div className="share-buttons">
          <button onClick={handleCopyToClipboard}>
            <img src={LinkIcon} />
            링크복사
          </button>
          <button onClick={handleClickKakao}>
            <img src={KakaoIcon} />
            카카오톡
          </button>
        </div>
      </div>

      <div className="alert-footer share">
        <div className="alert-footer-button" onClick={handleClose}>
          닫기
        </div>
      </div>
    </Dialog>
  );
};

export default memo(ShareAlert);
